import { render, staticRenderFns } from "./depperallsch.vue?vue&type=template&id=2c5ce7dd&scoped=true&"
import script from "./depperallsch.vue?vue&type=script&lang=js&"
export * from "./depperallsch.vue?vue&type=script&lang=js&"
import style0 from "./depperallsch.vue?vue&type=style&index=0&id=2c5ce7dd&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c5ce7dd",
  null
  
)

export default component.exports